import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/base/SimpleModal';
import { closePopup, getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';

import css from './style.scss';

/**
 * Renders DNC policy dialog
 * Used in:
 * I) Lead automator at subscription purchase
 */
const DNCPolicyModal = ({ closePopup, yesRedirect }) => {
  const handleClose = () => {
    closePopup();
  };

  return (
    <Modal
      uniqId="DNCPolicyModal"
      onCancel={handleClose}
      title="National 'Do Not Call' Registry Certification of Registration"
      description="Customer acknowledges that certain laws, rules, and regulations restrict telemarketing activities, including those that permit consumers to give notice that they do not wish to receive telephone solicitations, known as 'do not call' laws, rules, and regulations. Customer acknowledges and agrees that Customer is directly responsible for Customer's compliance with all Federal and State 'do not call' laws, rules, and regulations. Company does not warrant the correctness, completeness, currentness, merchantability or fitness for a particular purpose of the information provided and is not liable to Customer for any loss or injury arising out of, or caused in whole or in part by Company's provision of any information or Customer's use thereof. Customer agrees to defend, indemnify, and hold harmless Company and Company's affiliates and their respective directors, officers, members, managers, employees, agents and successors and assigns from and against any claim made by any third party that arises from or is in any way connected with Customer's use of the provided information in violation of federal or state 'do not call' laws, rules, or regulations, or this certification. Customer agrees that Customer will not provide any telephone number information provided by Company to Customer to any third party unless such third party either: (a) completes a Certification of Registration itself or (b) has made certifications and provided information to Customer similar in all material respects to the certifications made and information provided by Customer to Company herein."
      cancelText="OK"
      onSubmitRedirect={yesRedirect}
      modalClassName={css.clsDNCPolicyModal}
      wrapperClassName={css.clsDNCPolicyModalWrapper}
    />
  );
};

export default DNCPolicyModal;

const registrationId = getPopupRegistration(DNCPolicyModal);

DNCPolicyModal.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.HIGHEST });
DNCPolicyModal.close = () => closePopup({ popup: registrationId });

DNCPolicyModal.propTypes = {
  closePopup: PropTypes.func.isRequired,
  yesRedirect: PropTypes.func,
  autoWidth: PropTypes.bool,
};
